(function () {
  if (window.TwinkleMobileMenu) return;
  window.TwinkleMobileMenu = true;

  const DETAILS = 'details.mobile-menu__details';

  function panelFor(details) {
    const panel = details.nextElementSibling;
    if (!panel) return null;
    if (panel.classList.contains('mobile-menu__panel') || panel.classList.contains('mobile-menu__nested')) return panel;
    return null;
  }

  function closeDetails(details) {
    details.open = false;
    const panel = panelFor(details);
    if (!panel) return;
    panel.querySelectorAll(DETAILS).forEach((nested) => {
      nested.open = false;
    });
  }

  function keepOnly(details) {
    const menu = details.closest('.mobile-menu');
    if (!menu) return;

    const group = details.closest('.mobile-menu__panel, .mobile-menu__nested');
    const scope = group || menu;
    const selector = group ? DETAILS : '.mobile-menu__row > details.mobile-menu__details';

    scope.querySelectorAll(selector).forEach((other) => {
      if (!other.open || other === details) return;
      if (group && other.closest('.mobile-menu__panel, .mobile-menu__nested') !== group) return;
      closeDetails(other);
    });
  }

  function normalizeMenu(menu) {
    const topOpen = menu.querySelectorAll('.mobile-menu__row > details.mobile-menu__details[open]');
    topOpen.forEach((details, index) => {
      if (index > 0) closeDetails(details);
    });

    menu.querySelectorAll('.mobile-menu__panel').forEach((panel) => {
      const nestedOpen = [...panel.querySelectorAll(DETAILS)].filter((details) => {
        return details.open && details.closest('.mobile-menu__panel') === panel;
      });
      nestedOpen.forEach((details, index) => {
        if (index > 0) closeDetails(details);
      });
    });
  }

  function revealDetails(details) {
    const scroller = details.closest('.menu-drawer__navigation-container');
    if (!scroller) return;

    const isNested = Boolean(details.closest('.mobile-menu__panel, .mobile-menu__nested'));
    const target = isNested ? details : details.closest('.mobile-menu__row') || details;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(() => {
      const top =
        target.getBoundingClientRect().top -
        scroller.getBoundingClientRect().top +
        scroller.scrollTop -
        12;
      scroller.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    });
  }

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.classList.contains('mobile-menu__details') || !details.open) return;
      keepOnly(details);
      revealDetails(details);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a.mobile-menu__media-link');
      if (!link || !link.closest('.mobile-menu')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    },
    true
  );

  function init() {
    document.querySelectorAll('.mobile-menu').forEach(normalizeMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const menu = event.target.querySelector('.mobile-menu');
    if (menu) normalizeMenu(menu);
  });
})();
